module.exports = __webpack_public_path__ + "static/media/point_icon_06.a5ccf64a.svg";